export const escapePrintHtml = value => String(value ?? "").replace(/[&<>"']/g,character=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[character]));
export function printableBooking(booking) {
  return { ...booking, ...Object.fromEntries(["lodgeName","lodgeNumber","time","allergies","diners"].map(key=>[key,escapePrintHtml(booking[key])])),
    selectedCourses:Object.fromEntries(Object.entries(booking.selectedCourses||{}).map(([key,value])=>[key,value?escapePrintHtml(value):value])) };
}

export function treasurerEmailPrintLine(emails) {
  const values = [...new Set((emails || []).filter(Boolean).map(email => String(email).trim()).filter(Boolean))];
  return `<p style="font-size:13px;margin:8px 0 16px;overflow-wrap:anywhere"><strong>Treasurer email${values.length > 1 ? "s" : ""}:</strong> ${values.length ? values.map(escapePrintHtml).join("; ") : "Not recorded"}</p>`;
}
